export default __webpack_public_path__ + "static/media/loader.cb31fea5.gif";